import { render, staticRenderFns } from "./ResponsibilityAssignmentDropDown.vue?vue&type=template&id=6eceb8ea"
import script from "./ResponsibilityAssignmentDropDown.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityAssignmentDropDown.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityAssignmentDropDown.vue?vue&type=style&index=0&id=6eceb8ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports